<div class="dialog-confirm">
  <app-dialog-common [dialogCommonTitle]="dialogData.title">
    <div
      class="content-confirm"
      [innerHTML]="dialogData.content | translate"
    ></div>
    <div class="foot-confirm">
      <qima-button
        *ngIf="dialogData.hasCancel"
        [qimaButtonLabel]="dialogData.cancelButtonLabel || 'COMMON.CANCEL' | translate"
        [qimaButtonSize]="qimaButton.buttonSize.LARGE"
        [qimaButtonWidth]="qimaButton.buttonWidth.FULL"
        [qimaButtonStyle]="qimaButton.buttonStyle.SECONDARY"
        (qimaButtonClick)="close()"
      ></qima-button>
      <qima-button
        [qimaButtonLabel]="dialogData.confirmButtonLabel || 'COMMON.YES' | translate"
        [style.width.px]="dialogData.confirmButtonWidth || 'auto'"
        [qimaButtonSize]="qimaButton.buttonSize.LARGE"
        [qimaButtonWidth]="qimaButton.buttonWidth.FULL"
        [qimaButtonStyle]="dialogData.confirmButtonStyle || qimaButton.buttonStyle.PRIMARY"
        (qimaButtonClick)="confirm()"
      ></qima-button>
    </div>
  </app-dialog-common>
</div>
